// ShowPortraits.tsx
import React from "react";
import PortraitSelect from "../PortraitSelect";

const ShowPortraits = () => {

    const [selectedIndex, setSelectedIndex] = React.useState<number>(10);

    return (
        <>
            <PortraitSelect onSelect={setSelectedIndex}
                            initialValue={selectedIndex}
            />
            <span>Valeur {selectedIndex}</span>
        </>

    );
};

export default ShowPortraits;
